import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-zhuzhuangtu",
  "use": "icon-zhuzhuangtu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-zhuzhuangtu\">\r\n  <path d=\"M320 352H64v480h256V352z m-64 416H128V416h128v352zM640 64H384v768h256V64z m-64 704H448V128h128v640zM64 896h896v64H64z m640-64h256V224H704v608z m64-544h128v480H768V288z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/zhuzhuangtu.svg
// module id = N9af
// module chunks = 54